import { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import { load } from "@/redux/modules/api/data/stores/shopNames/shopNames.module";
import { getShopNames } from "@/redux/modules/api/data/stores/shopNames/shopNames.selector";

const useSingleStoreCheck = () => {
    const dispatch = useThunkDispatch();
    const shopNames = useSelector(getShopNames, shallowEqual);

    useEffect(() => {
        if (shopNames.length > 0) return;
        dispatch(load());
    }, [shopNames, dispatch]);

    return shopNames.length === 1 ? shopNames.at(0)?.code : undefined;
};

export { useSingleStoreCheck };
